import { IJobExpInfo } from './../../constants/models';

import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { JobService } from 'src/app/services/job.service';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import Swal from 'sweetalert2';
import { DriverLicenseType, EmploymentType } from 'src/app/constants/models';

@Component({
  selector: 'app-job-confirm',
  templateUrl: './job-confirm.component.html',
  styleUrls: ['./job-confirm.component.scss']
})
export class JobConfirmComponent implements OnInit {
  language = JSON.parse(localStorage.getItem('language'))
  Title: any = [this.language.jobpersonaltitle1, this.language.jobpersonaltitle2, this.language.jobpersonaltitle3]

  // setIcon
  Personal = true
  Education = true
  Family = true
  Experience = true

  // Ref
  ref_title: any = ''
  ref_fname: any = ''
  ref_lname: any = ''
  ref_position: any = ''
  ref_tel: any = ''
  ref_relation: any = ''

  // Check
  flag_illegal: any
  illegal_remark: any
  flag_NotPerfect: any
  NotPerfect_remark: any
  flag_sack: any
  sack_remark: any
  flag_WorkWithAsset: any
  WorkWithAsset_reamrk: any
  flag_confirm: any
  flag_pdpa: boolean
  Check1: boolean
  Check2: boolean
  chk: any
  hasCar:boolean = false
  hasMotorcycle:boolean = false
  driverLicenseType:string = DriverLicenseType.NONE
  employment:string = EmploymentType.AGENT
  employee:string = ''
  aboutYourself:string = ''

  count = 1
  clickCount = 0

  theCheckbox1 = false;
  theCheckbox2 = false;
  theCheckbox3 = false;
  theCheckbox4 = false;
  theCheckboxflag = false;
  theEmployeeShow = false;

  // Req
  submitted = false
  Reqflag_confirm = false
  Reqref_relation = false
  Reqref_tel = false
  Reqref_position = false
  Reqref_title = false
  Reqref_fname = false
  Reqref_lname = false

  Reqremark_illegal = false
  Reqremark_NotPerfect = false
  Reqremark_sack = false
  Reqremark_WorkWithAsset = false

  formDataRef: FormGroup;
  RefInfo: FormArray = new FormArray([]);

  constructor(
    private router: Router,
    private _JobApplyService: JobService,
    private fb: FormBuilder,
  ) {
    this.createform();   /// function  เรียกฟอรม
  }

  createItemAssign(): FormGroup {   /// form excisePersonInfo1  array
    return this.fb.group({
      ref_title: [],
      ref_fname: [],
      ref_lname: [],
      ref_position: [],
      ref_tel: [],
      ref_relation: []
    });
  }

  createform() {   /// form data
    this.formDataRef = this.fb.group({
      RefInfo: this.fb.array([this.createItemAssign()]),
    })
  }

  ngOnInit() {
    const personid = localStorage.getItem('personid');

    this.clickCount = 1;

    this.flag_illegal = false;
    this.flag_NotPerfect = false;
    this.flag_sack = false;
    this.flag_WorkWithAsset = false;
    this.flag_confirm = false;

    (document.getElementById('CAR2') as HTMLFormElement).checked = true;
    (document.getElementById('MOTORCYCLE2') as HTMLFormElement).checked = true;
    (document.getElementById('FLAG_NOTPERFECT2') as HTMLFormElement).checked = true;
    (document.getElementById('FLAG_ILLEGAL2') as HTMLFormElement).checked = true;
    (document.getElementById('FLAG_SACK2') as HTMLFormElement).checked = true;
    (document.getElementById('FLAG_WORKWITHASSET2') as HTMLFormElement).checked = true;
    (document.getElementById('EMPLOYMENT2') as HTMLFormElement).checked = true;

    this.illegal_remark = '';
    this.NotPerfect_remark = '';
    this.sack_remark = '';
    this.WorkWithAsset_reamrk = '';

  }

  handleChangeDriverLicense(e:any){
    // console.log('handleChangeDriverLicense',e.target.value,e.target.checked);
    const temp = document.getElementById('DRIVER_LICENSE1') as HTMLFormElement
    const per = document.getElementById('DRIVER_LICENSE2') as HTMLFormElement
    if(temp.checked && per.checked){
      this.driverLicenseType = DriverLicenseType.ALL;
    }else if(temp.checked){
      this.driverLicenseType = DriverLicenseType.TEMPORARILY;
    }else if(per.checked){
      this.driverLicenseType = DriverLicenseType.PERMANENT;
    }else{
      this.driverLicenseType = DriverLicenseType.NONE;
    }
  }
  handleChangeCar(e:any) {
    // console.log('handleChangeNotPerfect',e.target.value);
    this.hasCar = e.target.value == 'true';
  }
  handleChangeMotorCycle(e:any) {
    this.hasMotorcycle = e.target.value == 'true';    
  }
  handleChangeNotPerfect(e) {
    this.flag_NotPerfect = e.target.value == 'true'
    this.theCheckbox1 = this.flag_NotPerfect;
    // if (this.theCheckbox1) {
    //   (document.getElementById('flag_NotPerfect') as HTMLFormElement).checked = false;
    //   this.theCheckbox1 = false
    // } else {
    //   (document.getElementById('flag_NotPerfect') as HTMLFormElement).checked = true;
    //   this.theCheckbox1 = true
    // }

    // this.flag_NotPerfect = e.target.checked;
  }

  handleChangeillegal(e) {
    this.flag_illegal = e.target.value == 'true'
    this.theCheckbox2 = this.flag_illegal;
    // if (this.theCheckbox2) {
    //   (document.getElementById('flag_illegal') as HTMLFormElement).checked = false;
    //   this.theCheckbox2 = false
    // } else {
    //   (document.getElementById('flag_illegal') as HTMLFormElement).checked = true;
    //   this.theCheckbox2 = true
    // }
    // this.flag_illegal = e.target.checked;
  }

  handleChangesack(e) {
    this.flag_sack = e.target.value == 'true'
    this.theCheckbox3 = this.flag_sack;
  }

  handleChangeWorkWithAsset(e) {
    this.flag_WorkWithAsset = e.target.value == 'true'
    this.theCheckbox4 = this.flag_WorkWithAsset;
  }
  handleChangeEmployment(e:any){
    this.employment = e.target.value as EmploymentType
    this.theEmployeeShow = this.employment == EmploymentType.EMPLOYEE
  }
  handleChangeflag(e) {
    this.flag_confirm = e.target.checked;
  }

  onclickurgent_title(value) {
    this.ref_title = value
  }

  addLicense() {
    this.count = this.count + 1;
    this.clickCount = this.count;
    localStorage.setItem('clickCount', JSON.stringify(this.clickCount));

    this.RefInfo = this.formDataRef.controls.RefInfo as FormArray;
    this.RefInfo.push(this.fb.group({

      ref_title: [],
      ref_fname: [],
      ref_lname: [],
      ref_position: [],
      ref_tel: [],
      ref_relation: []
    }));
  }

  removeLicense() {
    const clickCount = localStorage.getItem(JSON.stringify(this.clickCount));
    this.RefInfo.removeAt(this.RefInfo.length - 1);
    this.clickCount = this.clickCount - 1;
  }

  goExperience() {
    this.router.navigate(['/job-apply-Experience']);
  }

  submit() {
    this.submitted = true;

    if (this.flag_confirm === undefined || this.flag_confirm === '') {
      this.Reqflag_confirm = true;
    } else {
      this.Reqflag_confirm = false;
    }

    // if (this.ref_relation === undefined || this.ref_relation === '') {
    //   this.Reqref_relation = true;
    // } else {
    //   this.Reqref_relation = false;
    // }

    // if (this.ref_tel === undefined || this.ref_tel === '') {
    //   this.Reqref_tel = true;
    // } else {
    //   this.Reqref_tel = false;
    // }

    // if (this.ref_position === undefined || this.ref_position === '') {
    //   this.Reqref_position = true;
    // } else {
    //   this.Reqref_position = false;
    // }

    // if (this.ref_lname === undefined || this.ref_lname === '') {
    //   this.Reqref_lname = true;
    // } else {
    //   this.Reqref_lname = false;
    // }

    // if (this.ref_fname === undefined || this.ref_fname === '') {
    //   this.Reqref_fname = true;
    // } else {
    //   this.Reqref_fname = false;
    // }

    // if (this.ref_title === undefined || this.ref_title === '') {
    //   this.Reqref_title = true;
    // } else {
    //   this.Reqref_title = false;
    // }


    const personid = localStorage.getItem('personid');

    const arrayControl = this.formDataRef.value.RefInfo;

    // for (let i = 0; this.RefInfo.length >= i; i++) {

    //   this.ref_title = arrayControl[i].ref_title || "-";
    //   this.ref_fname = arrayControl[i].ref_fname || "-";
    //   this.ref_lname = arrayControl[i].ref_lname || "-";
    //   this.ref_position = arrayControl[i].ref_position || "-";
    //   this.ref_tel = arrayControl[i].ref_tel || "-";
    //   this.ref_relation = arrayControl[i].ref_relation || "-";
    // }

    if (personid !== '') {
      let param:IJobExpInfo ={personid:personid,refs:[]}
      if (this.theCheckbox2 === true) {
        if (this.illegal_remark === undefined || this.illegal_remark === '' || this.illegal_remark === null) {
          this.Reqremark_illegal = true;
        } else {
          this.Reqremark_illegal = false;
        }
        this.flag_illegal = 'y';
      } else {
        this.Reqremark_illegal = false;
        this.flag_illegal = 'n';
      }

      if (this.theCheckbox1 === true) {
        if (this.NotPerfect_remark === undefined || this.NotPerfect_remark === '' || this.NotPerfect_remark === null) {
          this.Reqremark_NotPerfect = true;
        } else {
          this.Reqremark_NotPerfect = false;
        }
        this.flag_NotPerfect = 'y';
      } else {
        this.Reqremark_NotPerfect = false;
        this.flag_NotPerfect = 'n';
      }

      if (this.theCheckbox3 === true) {
        if (this.sack_remark === undefined || this.sack_remark === '' || this.sack_remark === null) {
          this.Reqremark_sack = true;
        } else {
          this.Reqremark_sack = false;
        }
        this.flag_sack = 'y';
      } else {
        this.Reqremark_sack = false;
        this.flag_sack = 'n';
      }

      if (this.theCheckbox4 === true) {
        if (this.WorkWithAsset_reamrk === undefined || this.WorkWithAsset_reamrk === '' || this.WorkWithAsset_reamrk === null) {
          this.Reqremark_WorkWithAsset = true;
        } else {
          this.Reqremark_WorkWithAsset = false;
        }
        this.flag_WorkWithAsset = 'y';
      } else {
        this.Reqremark_WorkWithAsset = false;
        this.flag_WorkWithAsset = 'n';
      }

      // check
      if (this.Reqremark_illegal || this.Reqremark_NotPerfect || this.Reqremark_sack || this.Reqremark_WorkWithAsset) {
      } else {
        if (this.flag_confirm) {
          param ={personid:personid,refs:[],flag_illegal:this.flag_illegal, illegal_remark:this.illegal_remark, flag_NotPerfect:this.flag_NotPerfect, NotPerfect_remark:this.NotPerfect_remark,flag_sack: this.flag_sack, sack_remark:this.sack_remark, flag_WorkWithAsset:this.flag_WorkWithAsset, WorkWithAsset_reamrk:this.WorkWithAsset_reamrk, flag_confirm:this.flag_confirm, flag_pdpa:this.flag_pdpa,aboutYourself:this.aboutYourself,driverLicenseType:this.driverLicenseType,hasCar:this.hasCar,hasMotorcycle:this.hasMotorcycle,employment:this.employment,employee:this.employee}
          // this._JobApplyService.setCheckExperience(personid, this.flag_illegal, this.illegal_remark, this.flag_NotPerfect, this.NotPerfect_remark, this.flag_sack, this.sack_remark, this.flag_WorkWithAsset, this.WorkWithAsset_reamrk, this.flag_confirm, this.flag_pdpa).subscribe(result => {
          //   if (result.returncode === '1000') {
          //     this.Check1 = true;
          //   }
          // })

          for (let i = 0; arrayControl.length > i; i++) {

            this.ref_title = arrayControl[i].ref_title || '';
            this.ref_fname = arrayControl[i].ref_fname || '';
            this.ref_lname = arrayControl[i].ref_lname || '';
            this.ref_position = arrayControl[i].ref_position || '';
            this.ref_tel = arrayControl[i].ref_tel || '';
            this.ref_relation = arrayControl[i].ref_relation || '';
            param.refs.push({ref_title:this.ref_title, ref_fname:this.ref_fname, ref_lname:this.ref_lname, ref_position:this.ref_position, ref_tel:this.ref_tel, ref_relation:this.ref_relation, seq:(i + 1).toString()})
            // this._JobApplyService.setExperienceReference(personid, this.ref_title, this.ref_fname, this.ref_lname, this.ref_position, this.ref_tel, this.ref_relation, i + 1).subscribe(result => {
            //   if (result.returncode === '1000') {
            //     this.Check2 = true;
            //   }
            // })
          }

          this._JobApplyService.setCheckExperiences(param).subscribe(result => {
            if (result.returncode === '1000') {
              this.Check1 = true;
            }
          })
          Swal.fire(
            'Success!',
            '',
            'success'
          )

          setTimeout(() => {
            Swal.close()
            this.router.navigate(['/job-list']);
          }, 1000);
        } else {
          Swal.fire({
            icon: 'error',
            title: this.language.jobcomfirmdetail10,
            // text: 'กดรับรองความถูกต้องของใบสมัครงานก่อนยกดยืนยัน',
          })
        }
      }

      // if (this.Reqflag_confirm == true || this.Reqref_title == true || this.Reqref_fname == true ||
      //   this.Reqref_lname == true || this.Reqref_position == true || this.Reqref_tel == true ||
      //   this.Reqref_relation == true) {
      //   alert("กรุณาตรวจสอบความถูกต้อง");
      // }
    }
  }
}
